export default __webpack_public_path__ + "static/media/alone_sample.d55ab07e.jpg";